import { testClaimPermissions, claimsPermissions } from "@/App/constants/permissions";

import { ReactComponent as DashboardClaimSearch } from "@/images/claim-search.svg";
import { ReactComponent as DashboardTestClaims } from "@/images/test-claims.svg";

import { DashboardItemProps } from "./DashboardItem";

export const DashboardListItems: Array<DashboardItemProps & { mainSection?: boolean; requiredPermissions: Array<string> }> = [
  {
    sectionImage: <DashboardClaimSearch />,
    url: "/claims-search",
    classes: "dashboard-claimsearch-link",
    title: "Claim Search",
    description: "Search for claims, view details, enter edits, etc.",
    mainSection: true,
    requiredPermissions: claimsPermissions,
  },
  {
    sectionImage: <DashboardTestClaims />,
    url: "/test-claim",
    title: "Test Claim Adjudication",
    requiredPermissions: testClaimPermissions,
  },
];
